module.exports = __webpack_public_path__ + "img/xls.aafb0233.png";